// ST-1288 -Claude- Network status hook — online / slow / offline.
import { useEffect, useState } from 'react';
import type { ConnectionState } from '@nearrme/ui-web';

export function useNetworkStatus(): ConnectionState {
  const [state, setState] = useState<ConnectionState>('online');

  useEffect(() => {
    const handleOffline = () => setState('offline');
    const handleOnline = () => {
      setState('recovered');
      setTimeout(() => setState('online'), 3000);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    if (!navigator.onLine) {
      setState('offline');
    }

    // ST-1288 -Claude- Probe Network Information API for slow-connection detection.
    const conn = (navigator as any).connection;
    if (conn) {
      const update = () => {
        if (!navigator.onLine) {
          setState('offline');
        } else if (['slow-2g', '2g'].includes(conn.effectiveType)) {
          setState('slow');
        } else {
          setState('online');
        }
      };
      conn.addEventListener('change', update);
      update();
      return () => {
        window.removeEventListener('online', handleOnline);
        window.removeEventListener('offline', handleOffline);
        conn.removeEventListener('change', update);
      };
    }

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return state;
}
